import React from 'react';

import { useEditorTabStateSelector } from 'src/editor/editor-tab-state-registry';
import { useEditingHooks } from 'src/editor/helpers/useEditingHooks';
import { ClientTransforms } from 'src/editor/transforms';
import { useAuthorizedTransforms } from 'src/hooks';

import { GenericColorSelect } from '../shared/GenericColorSelect';

export const HighlightColorSelect = React.memo(function HighlightSelectComponent(): JSX.Element {
  const { AuthorizedTransforms } = useAuthorizedTransforms();
  const { currentUserId, editingMode, editor, editorLoading } = useEditingHooks();
  const fontHighlightColor = useEditorTabStateSelector(
    state => state.derived.fontProperties.fontHighlight
  );

  function selectHighlightColor(color: string | null): void {
    if (!currentUserId || !editingMode) return;

    AuthorizedTransforms.applyHighlightColor(editor, {
      authorId: currentUserId,
      color,
      editingMode,
    });
    ClientTransforms.focus(editor);
  }

  return (
    <GenericColorSelect
      color={fontHighlightColor}
      editorLoading={editorLoading}
      hasTransparentOption={true}
      iconType="marker"
      tooltipTitle="Highlight color"
      onSelectColor={selectHighlightColor}
    />
  );
});
